import * as actions from './phase0.actions'

const initialState = {
  error: false,
  isTutorialPlayed: false,
}

const actionsMap = {
  [actions.SAVE_COLONY_NAME]: (state) => {
    return {
      ...state,
      saving: true,
      error: false,
    }
  },

  [actions.SAVE_COLONY_NAME_OK]: (state) => {
    return {
      ...state,
      saving: false,
      nameInserted: true,
      error: false,
    }
  },

  [actions.SAVE_COLONY_SHIELD]: (state) => {
    return {
      ...state,
      saving: true,
      error: false,
    }
  },

  [actions.SAVE_COLONY_SHIELD_OK]: (state) => {
    return {
      ...state,
      saving: false,
      shieldInserted: true,
      error: false,
    }
  },

  [actions.SAVE_COLONY_SETTINGS_ERROR]: (state, action) => {
    return {
      ...state,
      saving: false,
      error: true,
      errorMessage: action.data,
    }
  },

  [actions.TUTORIAL_PLAYED]: (state) => {
    return {
      ...state,
      isTutorialPlayed: true,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
